module.exports = __webpack_public_path__ + "static/media/Poster_rivemo_v3.ddbbfba4.pdf";